import { forwardRef } from "react";
import styles from "@/interface/ContextMenu/ContextMenu.module.css";
import type { MenuItem as MenuItemType } from "@/interface/ContextMenu/types";
import { Submenu } from "./Submenu";

type MenuItemProps = {
    item: MenuItemType;
    onClick?: (code: string) => void;
    openedSubmenu: string | null;
    setOpenedSubmenu: (name: string | null) => void;
};

export const MenuItem = forwardRef<HTMLDivElement, MenuItemProps>(
    ({ item, onClick, openedSubmenu, setOpenedSubmenu }, ref) => {
        const isSubmenuOpen = openedSubmenu === item.name;

        const handleClick = () => {
            if (!item.submenu) {
                onClick?.(item.name);
                setOpenedSubmenu(null);
            }
        };

        const handleMouseEnter = () => {
            if (item.submenu) {
                setOpenedSubmenu(item.name);
            } else {
                setOpenedSubmenu(null);
            }
        };

        if (item.name === "divider") {
            return <div ref={ref} className={styles.contextMenuDivider} />;
        }

        return (
            <div ref={ref} className={styles.buttonWrapper} onMouseEnter={handleMouseEnter}>
                <button type="button" className={styles.contextMenuItem} onClick={handleClick}>
                    <p className={styles.contextMenuItemName}>{item.label}</p>
                    {item.shortCut && (
                        <p className={styles.contextMenuItemShortcut}>{item.shortCut}</p>
                    )}
                </button>

                {item.submenu && isSubmenuOpen && (
                    <Submenu items={item.submenu} onClick={(code) => onClick?.(code)} />
                )}
            </div>
        );
    },
);
